import React from "react";
import { AnimatedTooltip } from "./AnimatedTooltip";
import { OctagonAlert } from "lucide-react";
import { cn } from "../lib/utils";

const CustomLabelText = ({
  required = false,
  labelText,
  errorField,
  className,
  bottomAlign=false,
  leftAlign=false,
}) => {
  return (
    <div className={cn("flex items-center justify-between flex-1", className)}>
      <div className={errorField ? "" : "w-full"}>
        {required && <span className="text-[#AF1763] font-bold">*</span>}
        {labelText}
      </div>
      {errorField && (
        <AnimatedTooltip title={errorField} bottomAlign={bottomAlign} leftAlign={leftAlign}>
          <span className="text-danger text-red-400">
            <OctagonAlert height={16} width={16} />
          </span>
        </AnimatedTooltip>
      )}
    </div>
  );
};

export default CustomLabelText;
